export var KnowledgeCardsIntentType = /*#__PURE__*/function (KnowledgeCardsIntentType) {
  KnowledgeCardsIntentType["PERSON"] = "PERSON";
  KnowledgeCardsIntentType["TEAM"] = "TEAM";
  return KnowledgeCardsIntentType;
}({});
export var KnowledgeCardsRowType = /*#__PURE__*/function (KnowledgeCardsRowType) {
  KnowledgeCardsRowType["PERSON"] = "PERSON";
  KnowledgeCardsRowType["WORK"] = "WORK";
  return KnowledgeCardsRowType;
}({});